import Cookies from 'js-cookie';

$(function(){

    const info_modal_hidden = (Cookies.get('info-modal-hidden') === 'true') ? true : false;
    var $info_modal = $('.info-modal');
    var $info_modal_close_trigger = $('[data-hide-info-modal]');
    var info_modal_visible_class = 'info-modal--visible';
    // show modal when not hidden
    if (info_modal_hidden === false) {
        setTimeout(function(){
            $info_modal.addClass(info_modal_visible_class);
        },1000);
    }
    // hide modal on click
    $info_modal_close_trigger.on('click',function(e){
        e.preventDefault();
        $info_modal.removeClass(info_modal_visible_class);
        // write cookie
        Cookies.set('info-modal-hidden', 'true', { expires: 365, path: '/' });
    });

});



// WEBPACK FOOTER //
// ./static/js/modules/info-modal.js